export const CHECKOUT_EVENTS = {
    MESSAGE_FROM_CHECKOUT: 'messageFromCheckout',
    CHECKOUT_OPENED: 'checkoutOpened',
    CHECKOUT_CLOSED: 'checkoutClosed',
} as const;

export const CHECKOUT_MESSAGE_SOURCES = {
    BOOKINGKIT_WIDGET: 'bookingkit_widget',
    BOOKINGKIT_CHECKOUT: 'bookingkit_checkout',
} as const;

export const CHECKOUT_MESSAGE_NAMES = {
    CHECKOUT_OPENED: 'checkout_opened',
    CHECKOUT_CLOSED: 'checkout_closed',
} as const;

export type CheckoutMessageSource = typeof CHECKOUT_MESSAGE_SOURCES[keyof typeof CHECKOUT_MESSAGE_SOURCES];

export type CheckoutOpenedMessage = {
    source: typeof CHECKOUT_MESSAGE_SOURCES.BOOKINGKIT_CHECKOUT;
    event: typeof CHECKOUT_MESSAGE_NAMES.CHECKOUT_OPENED;
}

export type CheckoutClosedMessage = {
    source: typeof CHECKOUT_MESSAGE_SOURCES.BOOKINGKIT_CHECKOUT;
    event: typeof CHECKOUT_MESSAGE_NAMES.CHECKOUT_CLOSED;
}

export type CheckoutEvents = {
    [CHECKOUT_EVENTS.MESSAGE_FROM_CHECKOUT]: any
    [CHECKOUT_EVENTS.CHECKOUT_OPENED]: CheckoutOpenedMessage
    [CHECKOUT_EVENTS.CHECKOUT_CLOSED]: CheckoutClosedMessage
}
